<template>
  <transition name='surveys'>
    <div class="surveys-notifications">
        <div class="surveys-notifications__header">
          <h5 v-text="`You have ${surveys.length} Survey${surveys.length > 1 ? 's' : ''} to complete`"></h5>
          <i class="material-icons" @click="$emit('dismiss-notifications')">close</i>
        </div>
        <div class="surveys-notifications__body">
          <div
            v-for="(survey, key) in surveys"
            :key="key"
            class="surveys-notifications__body__survey"
            @click="$emit('select-survey', survey.s_id)"
          >
            <p v-text="survey.title"></p>
            <button @click="$emit('select-survey', survey.s_id)" class="btn">View</button>
          </div>
        </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'surveys-notifications',
    props: {
      surveys: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '../scss/variables';
  @import '../scss/bp';

  .surveys-notifications {
    position: fixed;
    bottom: 100px;
    left: 20px;
    background: $white;
    z-index: 100;
    box-shadow: 0 0 10px -3px rgba($black, .4);
    max-width: 90%;

    @include bp(min-width, 426px) {
      bottom: 50px;
      left: 50px;
    }

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      border-bottom: 1px solid rgba($black, .1);

      i {
        margin-left: 20px;
        cursor: pointer;
      }
    }

    &__body {
      &__survey {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        transition: all .2s;
        cursor: pointer;

        &:hover {
          background: rgba($black, .1);
        }

        p {
          margin: 0;
          padding: 0;
        }

        .btn {
          padding: 5px 10px;
          background: none;
          border: none;
          color: $black;
          cursor: pointer;
          text-transform: uppercase;

          &:hover {
            background: rgba($black, 0.1);
          }
        }
      }
    }
  }

</style>